import { BoardView } from './BoardBase';
import { ShelfBoardScaffold } from './ShelfBoardScaffold';
import { OliGroup } from './groupByOli';

interface Props {
	view?: BoardView;
	selectedGroup?: OliGroup | null;
	onSelect?: (g: OliGroup | null) => void;
}

/** MSA board — rack/shelf grid across the active material-staging areas. The
 *  `view` prop is accepted for interface parity but the shelf grid is always
 *  rendered (no list mode); selection is lifted to the tablet page's left
 *  sidebar. */
export const MSABoard = ({ selectedGroup, onSelect }: Props = {}) => (
	<ShelfBoardScaffold
		area="msa"
		title="MSA"
		areaType="material_staging"
		storageKey="kt_default_msa_area_id"
		selectedGroup={selectedGroup}
		onSelect={onSelect}
	/>
);
